import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { ColorThemeContext, grid } from '@shared/styles';
import { MBBlockLabel } from '../../utils/label';

interface Props {
  label: string;
  onEditCards?(): void;
}
export function RelatedCardsHeader({ label, onEditCards }: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <View row fullWidth centerVertically paddingBottom={1}>
      <MBBlockLabel label={label} />
      <View fill />
      {onEditCards && (
        <MBTouchableOpacity onPress={onEditCards}>
          <MBIconV2 name="plus-circle" size={grid(5)} color={colors.foregroundActive} />
        </MBTouchableOpacity>
      )}
    </View>
  );
}
